import React from 'react';
import loadable from '@loadable/component';
import { privacyOnEnterSaga } from 'containers/Privacy/privacy.onenter.saga';
import { redirectTo } from 'helpers/path';

const PrivacyContainer = loadable(() => import('features/Privacy/PrivacyContainer'));

const rootPath = '/privacy';
export const PrivacyRoute = store => ({
  path: rootPath,

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(privacyOnEnterSaga, store, nextState, replaceState)
      .toPromise()
      .then(cb),

  indexRoute: { component: props => <PrivacyContainer {...props} /> },

  childRoutes: [
    { path: 'australia', onEnter: redirectTo(`${rootPath}/aus`) },
    { path: 'canada', onEnter: redirectTo(`${rootPath}/can`) },
    { path: 'uk', onEnter: redirectTo(`${rootPath}/gbr`) },
    { path: ':countryCode', component: props => <PrivacyContainer {...props} /> },
  ],
});
